<template>
  <div
    class="font-wrapper"
    :style="{ lineHeight: `${textSize}px`, height: `${textSize}px` }"
  >
    <span
      class="top-side"
      :content="text"
      :style="{ 'font-size': `${textSize}px` }"
    >
      {{ text }}
    </span>
    <span
      class="bottom-side"
      :content="text"
      :style="{ 'font-size': `${textSize}px`, top: `-${textSize}px` }"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, default: '', required: true },
    textSize: { type: String, default: '61', required: false },
  },
};
</script>

<style lang="scss" scoped>
.font-wrapper {
  padding-right: 4px;
  filter: drop-shadow(0 0 10px #195FF5);

  .top-side,
  .bottom-side {
    display: flex;
    font-weight: 800;
    color: #25F4EE;
    position: relative;
    top: 0;
    left: 0;
    mix-blend-mode: lighten;
  }

  .top-side:after,
  .bottom-side:after {
    content: attr(content);
    font-weight: 800;
    color: #FC1E96;
    top: -3.5px;
    left: 1.5px;
    position: absolute;
    mix-blend-mode: screen;
  }

  .top-side {
    padding-right: 4px;
    clip-path: inset(0 0 53% 0);
    left: 3px;
    top: 0;
  }

  .bottom-side {
    clip-path: inset(45% 0 0 0);
    top: -60px;
  }
}
</style>
